import { WithStyles, withStyles } from '@mui/styles';
import { ACGWithMappedUsers } from '@tassat/fred-extended-definitions';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { ACGNumberGrid } from './ACGNumberGrid';
import { muiStyles } from './ACGNumberGridStyles';

export interface AcgNumberGridProps extends WithStyles<typeof muiStyles>, RouteComponentProps<any> {
    filterModel: any;
    setFilterModel: React.Dispatch<React.SetStateAction<any>>;
    acg: ACGWithMappedUsers[];
    acgID?: string;
    ACGId?: string;
}

export default withRouter(withStyles(muiStyles)(ACGNumberGrid));